import { Component, OnInit, inject } from '@angular/core';
import { AppConfig } from "app/app.config";
import { LoaderService } from "app/services/loader.service";
import { APIService } from 'app/services/api.service';
import { AuthenticationService, reRgType } from 'app/services/auth.service';
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { NgClass, DatePipe } from '@angular/common';
import { ClickStopPropagationDirective } from '../../components/Controls/click-stop-propagation.directive';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';

type messageType = {
  Id: null | number;
  NotificationId: 12,
  Type: null | string;
  Title: string;
  Text: string;
  NotificationCreated: string;
  AssignedToUser: string;
  Viewed: null | string;
  ShowToAll: boolean;
  TotalRows: number;
  Preview: string;
  KYClink: boolean;
  expanded: boolean;
};

@Component({
    selector: 'nwm-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: [`./notifications.component.scss`],
    imports: [MenuComponent, NgClass, ClickStopPropagationDirective, NgbPagination, DatePipe]
})

export class NotificationsComponent implements OnInit {
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);
  private api = inject(APIService);
  auth = inject(AuthenticationService);

  public messages: messageType[] = [];
  public page = 1;
  public totalPages = 1;
  public pageSize: number = this.config.document.documentPageSize;
  public totalRows = 0;

  public reRg?: reRgType;
  public isImpersonated = false;

  ngOnInit(): void {
    this.isImpersonated = !!sessionStorage.getItem('guid');
    this.reRg = this.auth.getCurrentReRg();
    this.getNotifications();
  }

  loadPage() {
    this.getNotifications();
  }

  getNotifications() {
    this.loaderService.display(true, 'Notifications');
    this.api.get(`${this.config.profile.notificationsUrl}/${this.reRg?.ReRgId}/${this.page - 1}/${this.pageSize || 20}`).subscribe(
      data => {
        this.loaderService.display(false, 'Notifications');
        this.messages = [];
        if (Array.isArray(data)) {
          this.messages = data;
          this.messages.forEach(m=>{
            m.Preview = m.Text.replace(/(<([^>]+)>)/ig," ");
            m.KYClink = m?.Type?.indexOf('KYC') === 0;
          });
          this.totalRows = this.messages[0] ? this.messages[0].TotalRows : 0;
          this.totalPages = Math.ceil(this.totalRows / this.pageSize);
          if (this.totalPages < this.page) this.page = this.totalPages;
        } else {
          this.page = 1;
          this.totalPages = 1;
        }
      },
      () => this.loaderService.display(false, 'Notifications')
    );
  }

  expand(m: messageType) {
    m.expanded = !m.expanded;
    if (!m.Viewed && !this.isImpersonated) {
      m.Viewed = '1';
      this.api.get(`${this.config.profile.markNotificationViewUrl}/${this.reRg?.ReRgId}/${m.Id ? m.Id : 0}/${m.NotificationId}`).subscribe(
        () => {
          this.auth.loadNewNotificationsCount();
        }
      );
    }
  }

}